// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"216":"35053232","271":"9601d923","389":"66fb8410","390":"cc53ec71","700":"bc4b7607","878":"7cd14e21","947":"22869b20"}[chunkId] + ".chunk.js";
};